const _Hub_Name = "AppointmentHub";

const _Invoke_Methods_Names = {
  createEventDetails: "CreateCalendar",
  updateEventDetails: "UpdateCalendar",
  deleteEventDetails: "DeleteCalendar",

  appointmentBooking: "BookAppointment",
  appointmentCancellation: "CancelAppointment",
  appointmentReschedule: "RescheduleAppointment",
  appointmentUpdate: "UpdateAppointment",
  appointmentDelete: "DeleteAppointment",
  appointmentComplete: "CompleteAppointment",

  purchaseSmsNumber: "PurchaseSmsNumber",
  releaseSmsNumber: "ReleaseSmsNumber",
};

const _OnReceive_Methods_Names = {
  onCreateEventDetailsResponse: "CreateCalendarResponse",
  onUpdateEventDetailsResponse: "UpdateCalendarResponse",
  onDeleteEventDetailsResponse: "DeleteCalendarResponse",

  onAppointmentBookingResponse: "BookAppointmentResponse",
  onAppointmentCancellationResponse: "CancelAppointmentResponse",
  onAppointmentRescheduleResponse: "RescheduleAppointmentResponse",
  onAppointmentRescheduleResponse: "RescheduleAppointmentResponse",
  onAppointmentUpdateResponse: "UpdateAppointmentResponse",
  onAppointmentDeleteResponse: "DeleteAppointmentResponse",
  onAppointmentCompleteResponse: "CompleteAppointmentResponse",

  onSmsNumberPurchase: "SmsNumberPurchaseResponse",
  onSmsNumberRelease: "SmsNumberReleaseResponse",
};

const Appointment_signalr = {
  hubName: _Hub_Name,
  InvokeMethodNames: _Invoke_Methods_Names,
  onReceiveMethodNames: _OnReceive_Methods_Names,
};

export default Appointment_signalr;
